import {getToken, onMessage} from 'firebase/messaging'
import {getMessagingInstance} from '../../lib/firebase'

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY

export const getFcmToken = async (): Promise<string | null> => {
  if (typeof window === 'undefined' || typeof Notification === 'undefined') {
    return null
  }

  try {
    const permission = await Notification.requestPermission()
    if (permission !== 'granted') {
      return null
    }

    const messaging = getMessagingInstance()
    if (!messaging) {
      return null
    }

    if (!VAPID_KEY) {
      return null
    }

    const token = await getToken(messaging, {vapidKey: VAPID_KEY})
    if (token) {
      console.log('--- NEW FCM TOKEN FOR BACKEND ---')
      console.log(token)
      console.log('--- END OF TOKEN ---')
      // @ts-ignore
      window.fcmToken = token
    }

    // Foreground notifications for debug
    onMessage(messaging, (payload) => {
      const title = payload?.notification?.title || 'Notification'
      const body = payload?.notification?.body || ''
      if (title || body) {
        // keep default browser behavior; do nothing here by default
      }
    })

    return token || null
  } catch (err) {
    return null
  }
}

